import type { NotificationItemComponent } from "./NotificationItem";
import React from "react";
import { Typography, Button } from "@mui/material";
import NotificationItem from "./NotificationItem";

import useCustomizeQuery from "@/components/newcustomize/hooks/useCustomizeQuery";
import { RouteLink } from "@/components/common/styles";

const UnlimitedBandwidthGetsThrottledNotification: NotificationItemComponent =
  ({ item }) => {
    const { link } = useCustomizeQuery({
      source: "notification",
      showCustomizeSections: ["bandwidth-plan"],
      existingPlanId: item.context.plan || "default",
    });

    return (
      <NotificationItem variant={!item.dismissed_at ? "warning" : "default"}>
        <NotificationItem.Title created_at={item.created_at}>
          <span>Temporary speed reduction detected</span>
        </NotificationItem.Title>
        <NotificationItem.Content>
          <Typography variant="body2">
            {
              "We noticed that your account's unusually high traffic triggered a temporary speed reduction under our fair usage policy. Upgrade to get an extra 100 GB for every $1, helping you maintain full-speed performance."
            }
          </Typography>
        </NotificationItem.Content>
        <NotificationItem.Actions {...item}>
          <RouteLink {...link}>
            <Button variant="contained">Upgrade</Button>
          </RouteLink>
        </NotificationItem.Actions>
      </NotificationItem>
    );
  };

export default UnlimitedBandwidthGetsThrottledNotification;
